import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { CustomCheckBox } from "hesus-ui-kit";
import { ColumnButton } from "@utils/extra-style";
import { documentTypeColor, documentName } from "@utils/constants";
import { FileInputLabel, DocumentRow } from "./DocumentUpload.styled";

const DocumentSelectWithType = (props) => {
  const { t, documents, formData, setFormData, selectedDocuments } = props;

  const onDocumentSelect = (e, id) => {
    if (selectedDocuments.indexOf(id) === -1 && e.currentTarget.checked)
      selectedDocuments.push(id);
    else {
      const index = selectedDocuments.indexOf(id.toString());
      if (index >= 0) {
        selectedDocuments.splice(index, 1);
      }
    }
    setFormData({
      ...formData,
      selectedDocuments: {
        value: selectedDocuments.length > 0 ? selectedDocuments.join() : "",
        error: "",
        required: true,
      },
    });
  };

  const getDocumentList = (files) => {
    let docs = [];
    for (let i = 0; i < files.length; i++) {
      docs[i] = (
        <div key={i}>
          {" "}
          <CustomCheckBox
            id={"document-" + files[i].id}
            labelText=""
            dataId={files[i].id}
            onChange={(e) => {
              onDocumentSelect(e, files[i].id);
            }}
            checked={selectedDocuments.indexOf(files[i].id.toString()) !== -1}
          />
          <ColumnButton
            border={documentTypeColor[parseInt(files[i].type?.id, 10)]}
            background={documentTypeColor[parseInt(files[i].type?.id, 10)]}
            marginRight="10px"
            marginLeft="10px"
          >
            <span>{t(documentName[parseInt(files[i].type?.id, 10)])}</span>
          </ColumnButton>
          {files[i].fileName}
        </div>
      );
    }
    return docs;
  };

  return (
    <>
      <div style={{ marginTop: "20px" }}>
        <FileInputLabel>{t("DOCUMENTS")}</FileInputLabel>
      </div>
      <DocumentRow marginTop="20px"> {getDocumentList(documents)} </DocumentRow>
    </>
  );
};

DocumentSelectWithType.propTypes = {
  t: PropTypes.func.isRequired,
};

DocumentSelectWithType.defaultProps = {};

export default withTranslation()(DocumentSelectWithType);
